import { Link, useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="w-full bg-black border-t border-gray-800 pt-12 pb-6 px-4 mt-auto z-10">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-end">

        {/* Left: Logo */}
        <div className="mb-8 md:mb-0 flex flex-col items-start">
          <div className="flex items-center mb-4">
            {/* Placeholder for logo icon */}
            <Link to="/" className="flex items-center text-lg sm:text-xl font-black tracking-wider shrink-0 space-x-2">
              <img 
                src="icons/white goclub.ico" 
                alt="Logo" 
                className="h-6 w-6 sm:h-8 sm:w-8"
              />
              <span>AFTR</span>
            </Link>
          </div>
        </div>

        {/* Center: Links */}
        <div className="flex flex-col md:flex-row gap-12 mb-8 md:mb-0">
          <div>
            <button className='text-whtie mb-2 font-medium' onClick={() => navigate('/infoevents')}>
              Arma tu evento
            </button>
            <div>
            <button className='text-whtie mb-2 font-medium' onClick={() => navigate('/carrera')}>
              Trabaja con Nosotros
            </button>
          </div>
          </div>
          <div>
            <button className='text-whtie mb-2 font-medium' onClick={() => navigate('/about')}>
              Sobre Nosotros
            </button>
            <div className="text-gray-400 font-medium">
              Marcas
            </div>
          </div>
          <div>
            <button className='text-whtie mb-2 font-medium' onClick={() => navigate('/support')}>
              Soporte
            </button>
            <div className="text-gray-400 font-medium">
              Devoluciones
            </div>
          </div>
        </div>

        {/* Right: Socials */}
        <div className="flex flex-col items-end gap-4">
          <div className="flex items-center gap-4 mb-2">
            {/* Placeholder icons for social and app store */}
            <a
              href="https://www.instagram.com/goclub.pe/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram AFTR"
              className="w-8 h-8 rounded-full flex items-center justify-center hover:text-pink-400 transition-colors"
            >
              <i className="fab fa-instagram fa-2xl"></i>
            </a>
            <span className="w-8 h-8 rounded-full flex items-center justify-center">
              <i className="fab fa-tiktok fa-2xl"></i>
            </span>
            <span className="w-8 h-8 rounded-full flex items-center justify-center">
              <i className="fab fa-apple fa-2xl"></i>
            </span>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-center mt-8 text-white text-sm">
        <button className="mb-2 md:mb-0" onClick={() => navigate('/terminos')}>
          Términos & Condiciones
        </button>
        <div>
          © 2026 AFTR.
        </div>
      </div>
    </footer>
  );
} 